import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";
import {ContractPaymentPlannedTypeDto} from "./contract-payment-planned-type.dto";
import {PlannedPaymentStatus} from "../../../enum/planned-payment-status.enum";

export class ContractPaymentPlannedDto extends DtoDetail{

    public contractDtoId : number;
    public contractDtoName : string;
    public startDate: Date;
    public endDate: Date;
    public dueDate: Date;
    public plannedTypeDto? : ContractPaymentPlannedTypeDto;
    public plannedTypeDtoId : number;
    public plannedTypeDtoName : string;
    public status: PlannedPaymentStatus;
    public amount: number;
    public remainingAmount: number;
    public currency: string;

}